module.exports = __webpack_public_path__ + "static/media/bum2_munich.b98f9796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/bum2_munich.jpg
// module id = 404
// module chunks = 0